import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { computed, onMounted, watch } from "vue";
import { AttributeListInputProps } from "@/types";
import { attributesStore } from "@/hooks";
import { AttributeGrid } from "@/components/common/display";
import AttributeInput from "./AttributeInput.vue";


/**
 * A list of inputs for a list of generic attributes.
 */
const __default__ = {
  name: "AttributeListInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifact: {}
  },
  setup(__props: any) {

const props = __props;

const layout = computed(() =>
  attributesStore.getLayoutByType(props.artifact.type)
);

const attributes = computed(() => props.artifact.attributes || {});

/**
 * Initializes the artifact's custom attributes.
 */
function initializeArtifact(): void {
  if (props.artifact.attributes) return;

  props.artifact.attributes = {};
}

onMounted(() => initializeArtifact());

watch(
  () => props.artifact,
  () => initializeArtifact()
);

return (_ctx: any,_cache: any) => {
  return (!!layout.value)
    ? (_openBlock(), _createBlock(_unref(AttributeGrid), {
        key: 0,
        layout: layout.value
      }, {
        item: _withCtx(({ attribute }) => [
          (!!attribute)
            ? (_openBlock(), _createBlock(AttributeInput, {
                key: 0,
                class: "q-mr-sm q-pb-md",
                attributes: attributes.value,
                attribute: attribute,
                "data-cy": `input-attribute-${attribute.key}`
              }, null, 8, ["attributes", "attribute", "data-cy"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["layout"]))
    : _createCommentVNode("", true)
}
}

})